import { createReducer, on } from '@ngrx/store';
import { BusinessActions, UsersActions, RouterActions, AppActions } from '@actions/index'
import { BusinessModel, LocationModel, UserBusinessModel } from '@models/index'
import { emptyBusinessModel } from 'src/app/core/utilities/data-utils';

export interface State {
  businesses: BusinessModel[];
  locations: LocationModel[];
  users: UserBusinessModel[];
  searchBusinessQuery: string;
  isExecutingTask: boolean;
  selectedBusinessProfile: BusinessModel;
  ContactsAddedOnPeriodOfTime: {count: number, locationId: string}[]
  error: string;
  total: number;
  successfullyArchived: boolean;
  successfullyDeArchived: boolean;
}

const initialState: State = {
  businesses: [],
  locations: [],
  searchBusinessQuery: '',
  isExecutingTask: false,
  selectedBusinessProfile: emptyBusinessModel(),
  error: "",
  ContactsAddedOnPeriodOfTime: [],
  total: 0,
  users: [],
  successfullyArchived: false,
  successfullyDeArchived: false,
};

export const reducer = createReducer(
  initialState,
  on(BusinessActions.searchBusinesses, (state) => ({ ...state, businesses: [], total: 0, isExecutingTask: true })),
  on(BusinessActions.searchBusinessesSuccess, (state, { data, total }) => ({ ...state, businesses: data, total, isExecutingTask: false })),
  on(BusinessActions.createBusinessSuccess, (state, { business }) => ({ ...state, businesses: [...state.businesses, business], selectedBusinessProfile: business })),
  on(BusinessActions.editBusinessSuccess, (state, { business }) => ({ ...state, selectedBusinessProfile: business })),
  on(BusinessActions.deleteBusinessSuccess, (state, { businessIdDeleted }) => ({ ...state, businesses: state.businesses.filter(business => business.id !== businessIdDeleted) })),
  on(BusinessActions.selectBusinessProfile, (state, { business }) => ({ ...state, selectedBusinessProfile: business })),
  on(BusinessActions.searchBusinessesByUserSuccess, (state, { businesses }) => ({ ...state, businesses })),
  on(BusinessActions.searchBusinessesLocationSuccess, (state, { locations }) => ({ ...state, locations })),
  on(BusinessActions.searchBusinessesUsersSuccess, (state, { users }) => ({ ...state, users })),
  on(UsersActions.createSentInvitationSuccess, (state, { sentInvitation }) => ({ ...state, users: [sentInvitation, ...state.users] })),
  on(UsersActions.addRoleToUserToBusinessSuccess, (state, { user }) => ({ ...state, users: [user, ...state.users] })),
  on(BusinessActions.searchBusinessesByReseller, (state) => ({ ...state, businesses: [], total: 0 })),
  on(BusinessActions.searchBusinessesByResellerSuccess, (state, { data, total }) => ({ ...state, businesses: data, total })),
  on(BusinessActions.searchBusinessesByResellerSuccess, (state, { data, total }) => ({ ...state, businesses: data, total })),  
  on(BusinessActions.searchBusinessByIdSuccess, (state, { business }) => ({ ...state, selectedBusinessProfile: business })),
  on(BusinessActions.searchContactsAddedOnPeriodOfTimeSuccess, (state, {data}) => ({ ...state, ContactsAddedOnPeriodOfTime: data })),
  on(BusinessActions.clearSelectedBusinessProfile, (state) => ({ ...state, selectedBusinessProfile: emptyBusinessModel() })),
  on(BusinessActions.deArchiveBusinessSuccess, (state, { business }) => {
    const containsBusiness = state.businesses.some(b => b.id == business.id);
    return {
      ...state,
      businesses: containsBusiness ? state.businesses : [business, ...state.businesses],
      total: containsBusiness ? state.total : state.total + 1,
      isExecutingTask: false,
      successfullyArchived: true
    };
  }),
  on(BusinessActions.archiveBusinessSuccess, (state, { businessId }) => {
    const hasBusiness = state.businesses.some(b => b.id == businessId);
    return {
      ...state,
      businesses: state.businesses.filter((item) => item.id != businessId),
      total: hasBusiness ? state.total - 1 : state.total,
      isExecutingTask: false,
      successfullyArchived: true
    };
  }),
  on(BusinessActions.clearSuccessfullyArchived, (state) => ({
    ...state,
    successfullyArchived: false
  })),
  on(BusinessActions.clearSuccessfullyDeArchived, (state) => ({
    ...state,
    successfullyDeArchived: false
  })),
  on(BusinessActions.businessError, (state, { error }) => ({ ...state, error })),
  on(AppActions.clearState, (state) => ({
    ...state,
    businesses: [],
    locations: [],
    searchBusinessQuery: '',
    total: 0,
    users: [],
  })),
  on(RouterActions.navigateAuth, () => ({ ...initialState }))
);

export const getIsTaskExecuting = (state: State) => state.isExecutingTask;
export const getBusinesses = (state: State) => state.businesses;
export const getLocations = (state: State) => state.locations;
export const getUsers = (state: State) => state.users;
export const getSelectedBusinessProfile = (state: State) => state.selectedBusinessProfile;
export const getContactsAddedOnPeriodOfTime = (state: State) => state.ContactsAddedOnPeriodOfTime
export const getSearchBusinessQuery = (state: State) => state.searchBusinessQuery;
export const getTotalBusinesses = (state: State) => state.total;
export const getSuccessfullyDeArchived = (state: State) => state.successfullyDeArchived;
export const getError = (state: State) => state.error;
